<template>
<div class="spend-time-tips">
  This timesheet is automatically generated by the MSP system, if you find the timesheet here does not match the actual meeting time length, you are able to make changes to your timesheet here.
</div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
.spend-time-tips{
  color: #ffa940;
  line-height: 24px;
}
</style>
